const en = {
  basicInformation: {
    labelMsg: {
      firstName: 'First Name',
      middleInitial: 'Middle Initial',
      lastName: 'Last Name',
      ssn: 'Social Security Number',
      address: 'Address',
      apt: 'Suite/Apt Number',
      city: 'City',
      state: 'State',
      zipCode: 'Zip Code',
      dob: 'Date of Birth',
      gender: 'Gender',
      maritalStatus: 'Marital Status'
    },
    validateMsg: {
      firstName: 'Please enter first name',
      lastName: 'Please enter last name',
      ssn: 'Please enter SSN',
      ssnFormat: 'It should match the format "123-45-6589"',
      address: 'Please enter address',
      city: 'Please enter city',
      state: 'Please enter state',
      zipCode: 'Please enter zip code',
      zipCodeFormat: 'It should be 5-digit or 9-digit',
      dob: 'Please enter date of birth',
      dobFormat: 'It should match the format "MM/DD/YYYY"',
      dobValideYear: 'It should be older than 10 and younger than 120',
      dobValide: 'Invalid date, something wrong in the day',
      gender: 'Please enter gender',
      maritalStatus: 'Please enter marital status'
    }
  },
  contactInformation: {
    labelMsg: {
      mainPhone: 'Main Phone Number',
      secondaryPhone: 'Secondary Phone Number',
      email: 'Personal Email Address',
      contactName: ' Please enter Emergency Contact Name',
      contactPhone: ' Please enter Emergency Contact Phone Number',
      contactRelationship: ' Please enter Emergency Contact Relationship'
    },
    validateMsg: {
      phoneNumber: 'Please enter phone number',
      phoneNumberFormat: 'It should match the format "(123) 456-7890"',
      email: 'Please enter email address',
      emailFormat: 'Invalid email address'
    }
  }
}

export { en }
